import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface OrderAmountPaid {
  amountPaid?: number
  error?: string
}

interface OrderAmountPaidState {
  [id: string]: OrderAmountPaid
}

const initialState: OrderAmountPaidState = {}

export const orderAmountPaidSlice = createSlice({
  name: 'orderAmountPaid',
  initialState,
  reducers: {
    setOrderAmountPaid: (state, action: PayloadAction<{ id: string; amountPaid: number }>) => {
      const { id, amountPaid } = action.payload
      if (!state[id]) {
        state[id] = {}
      }
      state[id].amountPaid = amountPaid
    },
    setOrderAmountPaidError: (state, action: PayloadAction<{ id: string; error: string }>) => {
      const { id, error } = action.payload
      if (!state[id]) {
        state[id] = {}
      }
      state[id].error = error
    },
  },
})

export const { setOrderAmountPaid, setOrderAmountPaidError } = orderAmountPaidSlice.actions

export default orderAmountPaidSlice.reducer
